import { render } from "./Consumer.vue?vue&type=template&id=68b24d05"
import script from "./Consumer.vue?vue&type=script&lang=js"
export * from "./Consumer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__